import React from 'react';
import { motion } from 'framer-motion';
import { Compass, FolderSearch, AlertTriangle, Lightbulb, ClipboardList, Moon } from 'lucide-react';
const pains = [{
  Icon: Compass,
  title: 'Buscás actividades en distintos lugares',
  desc: 'Pinterest, libros, blogs, grupos de Facebook... y nunca encontrás lo que necesitás.'
}, {
  Icon: FolderSearch,
  title: 'Guardás recursos que después no encontrás',
  desc: 'Tu Drive es un caos. Sabés que tenés ese PDF, pero no aparece nunca cuando lo necesitás.'
}, {
  Icon: AlertTriangle,
  title: 'Improvisás más de lo que te gustaría',
  desc: 'Llegás al aula sin tener claro qué hacer, y eso te genera ansiedad cada semana.'
}, {
  Icon: Lightbulb,
  title: 'Te faltan ideas nuevas',
  desc: 'Repetís las mismas consignas año tras año porque no tenés tiempo de renovar.'
}, {
  Icon: ClipboardList,
  title: 'Las planificaciones te consumen horas',
  desc: 'Armás todo desde cero cada año en vez de tener un sistema que funcione.'
}, {
  Icon: Moon,
  title: 'Terminás trabajando fuera de horario',
  desc: 'Noches, sábados, domingos. El trabajo no termina nunca y tu energía se va con él.'
}];
export function PainSection() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-132">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-134">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-135">
            ¿Te suena familiar?
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-136">
            Si sos docente de Arte, esto{' '}
            <span className="text-brand-500" data-id="element-137">seguramente te pasa</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-138">
          {pains.map((pain, i) => {
          const Icon = pain.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className="bg-ink-50 rounded-2xl p-6 border border-ink-100 hover:border-brand-200 hover:bg-white hover:shadow-card transition-all" data-id="element-139">
                <div className="w-12 h-12 rounded-xl bg-white text-brand-500 flex items-center justify-center mb-4 shadow-soft border border-ink-100" data-id="element-140">
                  <Icon className="w-6 h-6" data-id="element-141" />
                </div>
                <h3 className="font-bold text-lg text-ink-900 mb-2 leading-tight" data-id="element-142">
                  {pain.title}
                </h3>
                <p className="text-ink-600 text-sm leading-relaxed" data-id="element-143">
                  {pain.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}